import Vue from "vue";

import PressReleases from "./LeftNavMenu.vue";

export function load() {
    const selector = "left-nav-menu";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PressReleases, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
